/*global angular */

/**
 * The main Unica app module
 *
 * @type {angular.Module}
 */

require('./constants');

// CONTROLLERS
require('controllers/basic');

// SERVICES
require('services/basic/basic');
require('services/basic/status');
require('services/basic/auth');
require('services/basic/utility');

// DIRECTIVES
require('directives/fields');
require('directives/snippets');
require('directives/sticky');

// MODULES
require('modules/agenda/agenda');
require('modules/approvation-list/approvation-list');
require('modules/archive-admin/archive-admin');
require('modules/archive-event/archive-event');
require('modules/archive-media/archive-media');
require('modules/auth/auth');
require('modules/campaign/campaign');
require('modules/campaign-attachment/campaign-attachment');
require('modules/campaign-template/campaign-template');
require('modules/check/check');
require('modules/dashboard/dashboard');
require('modules/event/event');
require('modules/event-tag/event-tag');
require('modules/event-field/event-field');
require('modules/feedback-category/feedback-category');
require('modules/feedback/feedback');
require('modules/grand-prix/grand-prix');
require('modules/hospitality/hospitality');
require('modules/invitation/invitation');
require('modules/invitation-list/invitation-list');
require('modules/invitation-group/invitation-group');
require('modules/location/location');
require('modules/material/material');
require('modules/media/media');
require('modules/media-directory/media-directory');
require('modules/media-moderation/media-moderation');
require('modules/media-upload/media-upload');
require('modules/notification/notification');
require('modules/notification-template/notification-template');
require('modules/pages/pages');
require('modules/partner/partner');
require('modules/relator/relator');
require('modules/report/report');
require('modules/social-stream/social-stream');
require('modules/survey/survey');
require('modules/tools/tools');
require('modules/track/track');
require('modules/user/user');
require('modules/wiki/wiki');
require('modules/workshop/workshop');
require('modules/workshop-session/workshop-session');
require('modules/tutorial/tutorial');



Object.size = function(obj) {
	var size = 0, key;
	for (key in obj) {
		if (obj.hasOwnProperty(key)) size++;
	}
	return size;
};

if (typeof Object.assign != 'function') {
	Object.assign = function(target, varArgs) { // .length of function is 2
		'use strict';
		if (target == null) { // TypeError if undefined or null
			throw new TypeError('Cannot convert undefined or null to object');
		}

		var to = Object(target);

		for (var index = 1; index < arguments.length; index++) {
			var nextSource = arguments[index];

			if (nextSource != null) { // Skip over if undefined or null
				for (var nextKey in nextSource) {
					// Avoid bugs when hasOwnProperty is shadowed
					if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
						to[nextKey] = nextSource[nextKey];
					}
				}
			}
		}
		return to;
	};
}




moment.locale('it');

angular.module('unica', [

	// DEPENDENCIES
	'ui.router',
	'ngMaterial',
	'angularjsToast',
	'ncy-angular-breadcrumb',
	'imageupload',
	'angularFileUpload',
	'ngAnimate',
	'ngSanitize',
	'ui.bootstrap',
	'uiGmapgoogle-maps',
	'infinite-scroll',
	'angular-confirm',
	'ui.tinymce',
	'bootstrapLightbox',
	'videosharing-embed',
	'angular-loading-bar',
	'angular-sortable-view',
	'oc.lazyLoad',
	'colorpicker.module',
	'ngFileUpload',

	// CONSTANTS
	'unica_constants',

	// CONTROLLERS
	'unica.basic_controller',

	// SERVICES
	'unica.basic_services',

	// DIRECTIVES
	'unica.fields_directive',
	'unica.sticky_directive',
	'unica.snippets_directive',

	// MODULES
	'unica_agenda',
	'unica_auth',
	'unica_archive_admin',
	'unica_archive_event',
	'unica_archive_media',
	'unica_campaign',
	'unica_campaign_attachment',
	'unica_campaign_template',
	'unica_check',
	'unica_dashboard',
	'unica_event',
	'unica_event_field',
	'unica_event_tag',
	'unica_feedback_category',
	'unica_feedback',
	'unica_grand_prix',
	'unica_hospitality',
	'unica_invitation',
	'unica_invitation_list',
	'unica_invitation_group',
	'unica_approvation_list',
	'unica_location',
	'unica_material',
	'unica_media',
	'unica_media_directory',
	'unica_media_moderation',
	'unica_media_upload',
	'unica_notification',
	'unica_notification_template',

	'unica_pages',
	'unica_partner',
	'unica_relator',
	'unica_report',
	'unica_social_stream',
	'unica_survey',
	'unica_tools',
	'unica_track',
	'unica_user',
	'unica_wiki',
	'unica_workshop',
	'unica_workshop_session',
	'unica_tutorial'
])
	// .config(['$mdThemingProvider', function (themeProv) {
	// 	themeProv.setNonce('randomString')
	// }])

.config(function (LightboxProvider) {
	//LightboxProvider.fullScreenMode = true;
	LightboxProvider.templateUrl = './templates/modals/lightbox-modal.html';
})
	// .config(['$mdThemingProvider', function (themeProv) {
	// 	themeProv.setNonce('randomString')
	// }])
	.config(['$sceProvider', function($sceProvider) {
		$sceProvider.enabled(true);
	}])

.config(function($stateProvider, $urlRouterProvider, $httpProvider, $breadcrumbProvider) {

	$breadcrumbProvider.setOptions({
		prefixStateName: 'app.dashboard',
		templateUrl: './templates/layout/breadcrumb.html'
	});

	$httpProvider.interceptors.push('preventTemplateCache');
	$httpProvider.interceptors.push('statusInterceptor');
	$httpProvider.interceptors.push('authInterceptor');
	$httpProvider.defaults.headers.delete = { 'Content-Type' : 'application/json' };
	$httpProvider.defaults.withCredentials = true;

	$stateProvider
		.state('app', {
			url: '/app',
			abstract: true,
			templateUrl: './templates/layout.html',
			controller: 'BasicController'
		});

	$urlRouterProvider.otherwise('/app/dashboard');
})

.config(['$ocLazyLoadProvider', function($ocLazyLoadProvider) {
	$ocLazyLoadProvider.config({
		'debug': false
	});
}])

.run(function($confirmModalDefaults) {

	$confirmModalDefaults.templateUrl = '/templates/modals/modal.html';
// console.log($confirmModalDefaults.templateUrl);
//
// 	// per ogni elemento se ha attributo nonce lo scrivo nella console.log
// 	document.querySelectorAll('[nonce]').forEach(el => {
// 		console.log(el, el.getAttribute('nonce'), window.cspNonce);
// 		// prendo il content di <meta name="csp_nonce" content="{{ $csp_nonce }}">
// 		// var nonce = document\
//
//
// 		el.setAttribute('nonce', window.cspNonce);
// 	})
})

.filter('unsafe', ['$sce', function ($sce) {
	return function (input) {
		return $sce.trustAsHtml(input);
	}

}]);